import * as React from "react";
const SvgMinusCustom = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-54544085-9e6e-4d99-8c01-042d3813c2b2", "data-name": "uuid-f2619d4d-5adf-466c-9e22-b2c89a1ba0ef", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 1.5", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 12, height: 1.5, style: {
  fill: "currentColor",
  strokeWidth: 0
} }));
export default SvgMinusCustom;
